// https://svelte.dev/playground/c6a402704224403f96a3db56c2f48dfc?version=5.20.0

let intersectionObserver;

function ensureIntersectionObserver() {
  if (intersectionObserver) return;
  intersectionObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const eventName = entry.isIntersecting ? 'enterViewport' : 'exitViewport';
      entry.target.dispatchEvent(new CustomEvent(eventName));
    });
  });
}

export default function viewport(element) {
  ensureIntersectionObserver();
  intersectionObserver.observe(element);
  return {
    destroy() {
      intersectionObserver.unobserve(element);
    },
  };
}
